import { useReframe } from 'nike-re-framejs';

import { loggedIn$ } from '../../../common/h&s';

export default function ShowUnlogged({ children }) {
    const { subscribe } = useReframe();
    const isUserLoggedIn = subscribe(loggedIn$);
    return isUserLoggedIn ? null : children;
}
